import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from './ui/button';
import { Loader2, Download, AlertCircle } from 'lucide-react';
import html2pdf from 'html2pdf.js';
import { PrintableWarranty } from './Warranties';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PublicWarranty = () => {
  const { token } = useParams();
  const [warranty, setWarranty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const printableRef = useRef(null);

  useEffect(() => {
    const load = async () => {
      try {
        const r = await axios.get(`${API}/public/warranties/${token}`);
        setWarranty(r.data);
      } catch (e) {
        setError(e.response?.data?.detail || 'Garantie niet gevonden');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [token]);

  const handleDownload = async () => {
    if (!printableRef.current || !warranty) return;
    const opt = {
      margin: 10,
      filename: `Garantie-${warranty.number}.pdf`,
      image: { type: 'jpeg', quality: 0.96 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };
    await html2pdf().set(opt).from(printableRef.current).save();
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="w-8 h-8 animate-spin text-[#3da5a5]" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="text-center max-w-md">
          <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-3" />
          <h1 className="text-xl font-semibold text-gray-800 mb-1">Garantie niet gevonden</h1>
          <p className="text-sm text-gray-500">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-end mb-4">
          <Button onClick={handleDownload} className="bg-[#3da5a5] hover:bg-[#2d8585]" data-testid="download-public-warranty-pdf">
            <Download className="w-4 h-4 mr-2" /> PDF downloaden
          </Button>
        </div>
        <div className="bg-white shadow-lg rounded-md overflow-hidden">
          <PrintableWarranty warranty={warranty} ref={printableRef} />
        </div>
      </div>
    </div>
  );
};

export default PublicWarranty;
